/**
 * One place that turns an analytics number into the text a reader sees.
 *
 * This existed five times over — in the chart's value formatter, in the
 * stat figure, and separately in each of the two report-builder panels — and
 * the copies had already drifted: two rounded a percentage, one kept a
 * decimal, and only one of them had an answer for null. A figure that reads
 * `66.7%` on a card and `67%` on the tile pinned from it is the same class of
 * bug as a chart changing shape when it is pinned.
 *
 * Deliberately not locale-aware beyond currency. The app's numbers are
 * percentages and small scale scores, where a thousands separator never
 * appears and a swapped decimal mark would be read as a typo.
 */
/** What a missing figure looks like. A suppressed cell shows this too. */
export const NO_VALUE = '—';
export const formatNumber = (value, format = 'integer') => {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return NO_VALUE;
    }
    switch (format) {
        case 'percent0':
            return `${Math.round(value)}%`;
        case 'percent1':
            return `${value.toFixed(1)}%`;
        case 'decimal1':
            return value.toFixed(1);
        default:
            return String(Math.round(value));
    }
};
/**
 * A mean sits on the question's own scale, so it keeps a decimal; every other
 * measure is a proportion and reads as a whole percentage. Three components
 * were each deciding this for themselves.
 */
export const formatMeasure = (value, measure) => formatNumber(value, measure === 'mean' ? 'decimal1' : 'percent0');
/**
 * Money, which is the one place a thousands separator and a fixed two
 * decimals are wanted. Replaces the single remaining `numeral` call.
 */
export const formatCurrency = (value, currency = 'USD') => {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return NO_VALUE;
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value);
};
